import { createContext } from 'react';
import { ISearchDetail } from './searchDetail';

export type SearchDetailContextProps = {
  searchDetail: ISearchDetail;
  setSearchDetail: Function;
};

export const SearchDetailContext = createContext({} as SearchDetailContextProps);
